import formActions from "./formActions";
const allActionsForm = {
  formActions,
};

export default allActionsForm;
